// src/features/learner/components/ContentRenderers/OrderRenderer.js
import React from 'react';
import OrderViewer from '../../../units/OrderViewer';

export const OrderRenderer = ({
    unit,
    userAnswers,
    showFeedback,
    completedUnits,
    onAnswerSelect,
    onCheckAnswer,
    onMarkCompleted,
    onResetUnit,  // Add this prop
}) => {
    if (!unit) {
        return (
            <div className="unit-content">
                <p>No order question available</p>
            </div>
        );
    }

    return (
        <div className="unit-content">
            <OrderViewer
                unit={unit}
                userAnswers={userAnswers}
                showFeedback={showFeedback}
                completedUnits={completedUnits}
                onAnswerSelect={onAnswerSelect}
                onCheckAnswer={onCheckAnswer}
                onMarkCompleted={onMarkCompleted}
                onResetUnit={onResetUnit}  // Pass it down
            />
        </div>
    );
};